var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0024 3.33376C13.4491 3.33626 16.5441 5.75209 18.2824 9.79709C18.3507 9.95459 18.3507 10.1329 18.2824 10.2904C16.5449 14.3363 13.4491 16.7521 10.0024 16.7546H9.99741C6.55074 16.7521 3.45574 14.3363 1.71741 10.2904C1.64991 10.1329 1.64991 9.95459 1.71741 9.79709C3.45574 5.75209 6.55158 3.33626 9.99741 3.33376H10.0024ZM9.99991 4.58376C7.13658 4.58459 4.52491 6.62042 2.97491 10.0438C4.52491 13.4679 7.13574 15.5038 9.99991 15.5046C12.8641 15.5038 15.4749 13.4679 17.0249 10.0438C15.4749 6.62042 12.8641 4.58459 9.99991 4.58376ZM9.99966 6.78442C11.7972 6.78442 13.2597 8.24692 13.2597 10.0444C13.2597 11.8411 11.7972 13.3028 9.99966 13.3028C8.20216 13.3028 6.74049 11.8411 6.74049 10.0444C6.74049 8.24692 8.20216 6.78442 9.99966 6.78442ZM9.99966 8.03442C8.89133 8.03442 7.99049 8.93609 7.99049 10.0444C7.99049 11.1519 8.89133 12.0528 9.99966 12.0528C11.108 12.0528 12.0097 11.1519 12.0097 10.0444C12.0097 8.93609 11.108 8.03442 9.99966 8.03442Z",
    fill: "#171717"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.25ffb4fa.svg";
export { ForwardRef as ReactComponent };